import script from "./dependents-incorporation-form-step-2.vue?vue&type=script&setup=true&lang=js"
export * from "./dependents-incorporation-form-step-2.vue?vue&type=script&setup=true&lang=js"

import "./dependents-incorporation-form-step-2.vue?vue&type=style&index=0&id=38f4aa5c&lang=css"

const __exports__ = script;

export default __exports__